var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconFacebook = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "IconFacebook",
  x: "0px",
  y: "0px",
  viewBox: "0 0 45.9 27.8",
  style: {
    enableBackground: "new 0 0 45.9 27.8"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0ff{fill:none;stroke:#6FC9D1;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1ff{fill:none;stroke:#6FC9D1;stroke-width:0.75;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "st0ff",
  d: "M42.3,1H23l0,0H3.6C3.6,1,1,1.3,1,3.4v10.4V14v10.4c0,2.2,2.6,2.4,2.6,2.4H23l0,0h19.3c0,0,2.6-0.3,2.6-2.4V14 v-0.1V3.4C44.9,1.3,42.3,1,42.3,1z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1ff",
  d: "M18.9,11.6l3-0.1H27V12h-8.1V11.6L18.9,11.6z M21.8,10.1c0-2.6,1.2-4,3.5-4c0.8,0,1.7,0.1,2.6,0.7l-0.2,0.6 c-0.9-0.4-1.5-0.6-2.4-0.6c-2.1,0-3,1.5-3,3.4v11.7h-0.5V10.1z"
})))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconFacebook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconFacebook.6e5aa0bd.svg";
export { ForwardRef as ReactComponent };